/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseUserResourceProgressData } from './genericApiResponseUserResourceProgressData';
import type { GenericApiResponseUserResourceProgressMessage } from './genericApiResponseUserResourceProgressMessage';
import type { GenericApiResponseUserResourceProgressPagination } from './genericApiResponseUserResourceProgressPagination';
import type { GenericApiResponseUserResourceProgressError } from './genericApiResponseUserResourceProgressError';

export interface GenericApiResponseUserResourceProgress {
  data?: GenericApiResponseUserResourceProgressData;
  message?: GenericApiResponseUserResourceProgressMessage;
  pagination?: GenericApiResponseUserResourceProgressPagination;
  error?: GenericApiResponseUserResourceProgressError;
  statusCode?: number;
}
